export enum EPlantStatus {
  GENERATING = "GENERATING",
  OFFLINE = "OFFLINE",
  WAITING = "WAITING",
  FAULT = "FAULT",
  DISABLED = "DISABLED",
  ACTIVE = "ACTIVE",
  UNKNOWN = "UNKNOWN",
}
